<template>
	<div>
		<div class="asd-margin" style="margin-top: 0px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/admin' }">智慧残联</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin/setting' }">组织管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="el-row" style="margin-top: 20px;">
			<el-button @click="addo" size="mini" type="primary" icon="el-icon-plus">添加单位</el-button>
			<el-button v-if="false" size="mini" type="primary" icon="el-icon-plus">导入机构</el-button>
		</div>
		<el-table  :max-height="gettbheight"  :data="tableData" size="mini" border style="width: 100%;margin-top: 20px;">
			<el-table-column prop="name" label="机构名" width="180">
			</el-table-column>
			<el-table-column prop="name" label="类型" width="180">
			</el-table-column>
			<el-table-column prop="code" label="组织机构代码">
			</el-table-column>
			<el-table-column prop="area_name" label="所属区域">
			</el-table-column>
			<el-table-column label="办理权限">
				<template slot-scope="scope">
					<el-tag size="mini" style="margin-right: 2px;" v-for="(p,i) in scope.row.roles">{{p=="all"?'全部权限':p}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="changeA(scope.row)" type="text">修改</el-button>
					<el-button v-if="org.org_id!=scope.row.org_id" @click="delOrg(scope.row)" style="color:red" type="text">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<addorg ref="addorg" v-model="addshow" :type="type" :shuju="shuju"></addorg>
	</div>
</template>

<script>
	import addorg from "../components/admins/addorg.vue"
	export default {
		data() {
			return {
				tableData: [],
				addshow: false,
				type: false,
				shuju: {}
			}
		},

		components: {
			addorg
		},
		computed: {
			gettbheight() {
				return window.innerHeight - 220;
			},
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		methods: {
			async delOrg(row) {
				let tt = await this.$confirm('此操作将永久删除该单位, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async() => {
					let ans = await axios.post(this.$url + "admin/delorg", {
						token: this.info.uid,
						org_id:row.org_id
					});
					this.getdata();
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			

			},
			changeA(row) {
				this.type = true;
				this.shuju = row;
				this.$refs.addorg.init(row);
				this.addshow = true;
			},
			addo() {
				this.type = false;
				this.shuju = {};
				this.addshow = true;
				this.$refs.addorg.init({
					name: "",
					area: "",
					code: "",
					roles: []
				});
			},
			async getdata() {
				let ans = await axios.get(this.$url + "admin/orgs", {
					params: {
						token: this.info.uid,
						id: this.org.org_id,
					}
				});
				this.tableData = ans.data.lists;
			}
		},
		created() {
			this.getdata();
		}
	}
</script>

<style>
</style>
